import { forwardRef, type ComponentProps, type ComponentRef } from "react";

import { Pressable } from "../../primitives";

/**
 * `asChild` goes through Pressable on both platforms. Web: Pressable translates
 * the unified accessibility props to ARIA (a bare Slot passed them to the DOM
 * as-is) and gives the child keyboard activation. Native: Pressable merges into
 * the child, composes both press handlers and makes a disabled Button disable
 * its child (it used to wrap the child, so Button called SlotPressable itself).
 */
export const ButtonAsChild = forwardRef<
  ComponentRef<typeof Pressable>,
  ComponentProps<typeof Pressable>
>((props, ref) => <Pressable ref={ref} asChild {...props} />);

ButtonAsChild.displayName = "ButtonAsChild";
